import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { Button } from '@/common/components/Button/Button';
import {
  CardAction,
  TCardActionProps,
} from '@/common/components/CardAction/CardAction';
import { IconBadgeFile } from '@/common/components/IconBadgeFile/IconBadgeFile';
import { Icon } from '@/common/components/Icons/Icon';
import { useBreakpoints } from '@/common/hooks/useBreakpoints';
import * as Linking from 'expo-linking';

export type TCardActionDownloadProps = TCardActionProps & {
  loading?: boolean;
  fileUrl: string;
  onDownload?: () => void;
};

export function CardActionDownload({
  icon,
  loading,
  disabled,
  fileUrl,
  onDownload,
  plain,
  ...cardActionProps
}: TCardActionDownloadProps) {
  const { t } = useTranslation();
  const { md } = useBreakpoints(['md']);

  const downloadFile = () => {
    if (!fileUrl) {
      return;
    }

    if (Platform.OS === 'web') {
      window.open(fileUrl, '_blank');
    } else {
      Linking.openURL(fileUrl);
    }

    onDownload?.();
  };

  return (
    <CardAction
      {...cardActionProps}
      icon={<IconBadgeFile fileUrl={fileUrl} icon={icon} />}
      plain={plain || disabled}
      onPress={downloadFile}
      action={
        <Button
          variant="tertiary"
          size="sm"
          icon={<Icon icon="download" />}
          onPress={downloadFile}
          loading={loading}
          disabled={disabled}
        >
          {md ? t('general.action.download') : undefined}
        </Button>
      }
    />
  );
}
